import React from "react";
import CardlessEMITenure from "../CardlessEMITenure";
import "../style.css";

const EmiPlanSelection = ({
  tenures,
  showTenures,
  bankName,
  panLength,
  panPlaceholder,
  panNumber,
  setPanNumber,
  selectedTenure,
  setselectedTenure,
  checkPanCardEligible,
  submitButtonClicked,
  panCardInputErrorMessage,
  merchantPaymentData,
  bankData,
}) => (
  <>
    <h3 className="title-green">Select EMI plan for {bankName}</h3>
    <div className="tenure-list">
      {tenures.map((tenure) => (
        <CardlessEMITenure
          tenure={tenure}
          selectedTenure={selectedTenure}
          setselectedTenure={setselectedTenure}
          key={`cardless-emi-${bankName.toLowerCase()}-tenure-${
            tenure?.tenure_id
          }`}
          showTenures={showTenures}
          merchantPaymentData={merchantPaymentData}
          bankData={bankData}
        />
      ))}
    </div>

    <h3 style={{ marginTop: "10px" }}>{panPlaceholder}</h3>
    <div className="check-eligibility-section">
      <div className="form-group d-inline-block">
        <input
          className="form-control"
          type="text"
          id="pan"
          name="pan"
          placeholder={panPlaceholder}
          maxLength={panLength}
          autoComplete="off"
          value={panNumber}
          onChange={(e) => {
            const value = e.target.value.replace(/\s/g, "");
            setPanNumber(value);
          }}
        />
      </div>
      <button
        className="btn btn-green col-3"
        onClick={checkPanCardEligible}
        disabled={
          submitButtonClicked ||
          !Boolean(selectedTenure?.tenure_id && panNumber?.length === panLength)
        }
      >
        Check Eligibility
      </button>
    </div>
    {panCardInputErrorMessage && (
      <span className="text-red">{panCardInputErrorMessage}</span>
    )}
  </>
);

export default EmiPlanSelection;